import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';

import { Observable, BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';


@Injectable({providedIn: 'root'})
export class HTTPStatus {
    private requestInFlight$: BehaviorSubject<boolean>;
    constructor() {
        this.requestInFlight$ = new BehaviorSubject<boolean>( true );
    }

    updateHttpStatus( inFlight: boolean ) {
        this.requestInFlight$.next( inFlight );
    }

    getHttpStatus(): Observable<boolean> {
        return this.requestInFlight$.asObservable();
    }
}

enum Status {
    Idle,
    WaitingForCurtain,
    WaitingForClear
}

@Injectable({providedIn: 'root'})
export class HTTPListener implements HttpInterceptor {
    private httpStatus = inject(HTTPStatus);

    count = 0;

    private status = Status.Idle;
    private timeoutId: any;

    intercept( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
        let shouldRequestBlock = !req.headers.get('X-HIS-Block-UI') || req.headers.get('X-HIS-Block-UI') !== 'false';
        if ( shouldRequestBlock ) {
            if ( this.count === 0 ) {
                this.scheduleCurtainAction( true, Status.WaitingForCurtain, Status.WaitingForClear, 500 );
            }
            this.count++;
        }

        return next.handle( req ).pipe(
            finalize(() => {
                if ( shouldRequestBlock ) {
                    this.count--;
                    if ( this.count === 0 ) {
                        this.scheduleCurtainAction( false, Status.WaitingForClear, Status.WaitingForCurtain, 20 );
                    }
                }
            } )
        );
    }

    /**
     * schedules showing or hiding the curtain
     *
     * @param loading show the curtain? (e. g. true)
     * @param desiredStatus the desired status (e. g. WaitingForCurtain)
     * @param opositeStatus the oposite status (e. g. WaitingForClear)
     * @param delay number of milliseconds to wait
     */
    private scheduleCurtainAction( loading: boolean, desiredStatus: Status, opositeStatus: Status, delay: number ) {

        // Are we already waiting for the desired curtain state?
        if ( this.status === desiredStatus ) {
            return;
        }

        // Are we waiting for the oposite curtain status? => Cancel
        if ( this.status === opositeStatus) {
            window.clearTimeout( this.timeoutId );
        }

        this.status = desiredStatus;
        this.timeoutId = setTimeout(
            () => {
                this.httpStatus.updateHttpStatus( loading );
                this.status = Status.Idle;
            },
            delay );
    }

}
